import { apiRequest } from '@/lib/api/client';
// Fetches the global user-facing release notes from the ControlPlane (newest first). Routes to the
// control-plane base because `/release-notes` is a control-plane prefix (see resolveApiBase).
export async function fetchReleaseNotes() {
    return apiRequest('GET', '/release-notes');
}
